import React, { useEffect } from 'react';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

const GoogleAnalytics: React.FC = () => {
  useEffect(() => {
    // Check if scripts are already loaded
    if (window.dataLayer && window.gtag) {
      console.log('Google Analytics already initialized');
      return;
    }

    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];

    // Create and append the Google Analytics script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-70TZ628CHH';
    script1.onload = () => {
      console.log('Google Analytics script loaded');
    };
    document.head.appendChild(script1);

    // Create and append the Google Analytics initialization script
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-70TZ628CHH');
      gtag('config', 'AW-532672904');
      console.log('Google Analytics initialized');
    `;
    document.head.appendChild(script2);

    // Don't remove scripts on unmount as they need to persist
    return () => {
      console.log('Google Analytics component unmounted');
    };
  }, []);

  return null;
};

export default GoogleAnalytics; 